<template>
  <label class="form-checkbox +fg-blue">
    <div :class="{ '+center-content': isCentered }">
      <input
        v-model="card"
        :disabled="disable"
        class="form-checkbox__input"
        type="checkbox"
      />
      <span class="form-checkbox__faux-input icon">
        <svg
          class="icon__glyph"
          width="12"
          height="9"
          viewBox="0 0 12 9"
          fill-rule="evenodd"
        >
          <path d="M4.1 6.1L1.4 3.4 0 4.9 4.1 9l7.6-7.6L10.3 0z"></path>
        </svg>
      </span>
      <span :class="{ '+fg-gray-dark': disable }">
        {{ selectorText }}
      </span>
    </div>
  </label>
</template>

<script>
export default {
  props: {
    slug: {
      type: String
    },
    name: {
      type: String
    },
    image: {
      type: String
    },
    id: {
      type: String,
      default: ''
    },
    legacyId: {
      type: String,
      default: ''
    },
    rank: {
      type: String,
      default: ''
    },
    issuer: {
      type: String,
      default: ''
    },
    price: {
      type: String,
      default: ''
    },
    isCentered: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    card: {
      get() {
        return this.$store.getters.isCardSelected(this.slug)
      },
      set(value) {
        const card = this.cardPayload()
        if (value) {
          this.$store.dispatch('addCard', card)
        } else {
          this.$store.dispatch('removeCard', card)
        }

        let eventLocation = ''
        const isReview = window.location.pathname.match(/reviews/g)
        const isCategory = window.location.pathname.match(/credit-cards\/.*\//g)

        if (isReview) {
          eventLocation = 'review'
        } else if (isCategory) {
          eventLocation = 'category list'
        } else {
          eventLocation = 'CChub'
        }

        const tagular = window.tagular
        if (typeof tagular !== 'undefined') {
          tagular('beam', 'ProductClicked', {
            '@type': 'redventures.ecommerce.v1.ProductClicked',
            product: {
              productId: card.id,
              brand: card.issuer,
              price: card.price,
              name: card.name,
              location: eventLocation,
              position: card.rank,
              text: value
                ? 'Add Card to Comparison'
                : 'Remove Card from Comparison'
            }
          })
        }
      }
    },
    selectorText() {
      if (this.$store.getters.isCardSelected(this.slug)) {
        return 'Remove card from comparison'
      }
      if (this.maxReached) {
        return 'Max cards selected to compare'
      }
      return 'Add this card to compare'
    },
    disable() {
      return !this.$store.getters.isCardSelected(this.slug) && this.maxReached
    },
    maxReached() {
      return this.$store.getters.isMaxSelected
    }
  },

  methods: {
    cardPayload() {
      return {
        slug: this.slug,
        name: this.name,
        image: this.image,
        id: this.id,
        legacyId: this.legacyId,
        rank: this.rank,
        issuer: this.issuer,
        price: this.price
      }
    }
  }
}
</script>

<!-- eslint-disable -->
<style scoped>
.form-checkbox,
.form-radio {
  line-height: 1.5;
  align-items: center;
  cursor: pointer;
  display: flex;
  font-family: "Calibre-Semibold", Arial, sans-serif;
  position: relative;
}

.form-checkbox.\--small {
  font-size: 14px;
  font-size: .77778rem;
  line-height: 1.92857;
}

.form-checkbox.\--small .form-checkbox__faux-input {
  height: 14px;
  height: .77778rem;
  width: 14px;
  width: .77778rem;
  margin-right: 7px;
  margin-right: .38889rem;
  padding: 1.749px;
  padding: .09722rem;
}

.form-checkbox .form-checkbox__input {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.form-checkbox .form-checkbox__input.\--is-focusable:active,.form-checkbox .form-checkbox__input.\--is-focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto;
}

.form-checkbox .form-checkbox__faux-input {
  height: 19.999px;
  height: 1.11111rem;
  width: 19.999px;
  width: 1.11111rem;
  border-width: 1px;
  border-width: .05556rem;
  margin-right: 14px;
  margin-right: .77778rem;
  padding: 3.499px;
  padding: .19444rem;
  background-color: #fff;
  border-color: #a7a8af;
  border-style: solid;
  color: #fff;
  fill: #fff;
}

.form-checkbox.\--has-error .form-checkbox__faux-input {
  border-width: 1px;
  border-width: .05556rem;
  border-color: #fa6e56;
}

.form-checkbox:hover .form-checkbox__input:not([disabled]):checked~.form-checkbox__faux-input {
  border-color: #3139f2;
}

.form-checkbox .form-checkbox__input:focus:not([disabled]):checked~.form-checkbox__faux-input {
  background-color: #fff;
  border-color: #3139f2;
}

.form-checkbox .form-checkbox__input:focus~.form-checkbox__faux-input,.form-checkbox:hover .form-checkbox__input~.form-checkbox__faux-input {
  background-color: #fff;
  border-color: #3139f2;
}

.form-checkbox .form-checkbox__input:checked~.form-checkbox__faux-input {
  background-color: #fff;
  border-color: #a7a8af;
  color: #202020;
  fill: #202020;
}

.form-checkbox .form-checkbox__input:checked:focus~.form-checkbox__faux-input,.form-checkbox:hover .form-checkbox__input:not([disabled]):checked~.form-checkbox__faux-input,.form-radio .form-radio__input:focus:not([disabled]):checked~.form-radio__faux-input {
  background-color: #fff;
}

.form-checkbox .form-checkbox__input:disabled~.form-checkbox__faux-input {
  background-color: #e9e9ec;
  border-color: #e9e9ec;
  color: #e9e9ec;
  fill: #e9e9ec;
  pointer-events: none;
}

.form-checkbox
.form-checkbox__input:disabled~.form-checkbox__faux-input:hover {
  border-color: #a7a8af;
}

.form-checkbox
.form-checkbox__input:disabled:checked~.form-checkbox__faux-input {
  color: #6f707b;
  fill: #6f707b;
}
</style>
<!-- eslint-enable -->
